import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from "@angular/material/dialog";
import { EMAIL_REG } from "@/utils/constants";

@Component({
  selector: 'cosmos-cluster-send-email',
  templateUrl: './cluster-send-email.component.html',
  styleUrls: ['./cluster-send-email.component.scss'],
})
export class ClusterSendEmailComponent {
  public readonly _emailForm: FormGroup;

  public constructor(
    private _modalRef: MatDialogRef<ClusterSendEmailComponent>,
    private readonly _formBuilder: FormBuilder,
  ) {
    this._emailForm = this._formBuilder.group({
      email: [null, [Validators.required, Validators.pattern(EMAIL_REG)]],
    });
  }

  public closeModal(result?: string): void {
    this._modalRef.close(result);
  }
}
